import { useMemoizedFn } from 'ahooks';
import React, { useState } from 'react';
import { Form, Select } from 'tdesign-react';
import { connect } from 'react-redux';
import { getNamespacesOptions } from '@/services/topicService';
import { toTsOptions } from '@/utils/common';

const { FormItem } = Form;

// 租户、命名空间关联表单片段
// isEdit 编辑时候用，否则搜索条件用
function TNItems({ clusterName, tenantOptions, isEdit }) {
  const [nsOptions, setNsOptions] = useState([]);

  const loadNSOptions = useMemoizedFn(async (tenantVal) => {
    const options = await getNamespacesOptions({
      clusterName,
      tenant: tenantVal,
    });
    setNsOptions(options);
  });

  return (
    <FormItem>
      {({ reset }) => {
        return (
          <>
            <FormItem name='tenant' label={isEdit && '租户'} rules={isEdit && [{ required: true }]}>
              <Select
                options={toTsOptions(tenantOptions)}
                onChange={(val) => {
                  setNsOptions([]);
                  reset({ fields: ['namespace'] });
                  if (val) {
                    loadNSOptions(val);
                  }
                }}
                placeholder='请选择租户'
                clearable
              />
            </FormItem>
            <FormItem
              name='namespace'
              label={isEdit && '命名空间'}
              rules={isEdit && [{ required: true }]}
            >
              <Select
                options={toTsOptions(nsOptions)}
                clearable
                filterable
                placeholder='请选择命名空间'
                popupProps={{ overlayInnerStyle: { width: 'auto', minWidth: 200 } }}
              />
            </FormItem>
          </>
        );
      }}
    </FormItem>
  );
}

export default connect((state) => ({
  tenantOptions: state.tenant.tenantOptions,
}))(TNItems);
